/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AccidentReviewCsiFileTypeDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: AccidentReviewCsiFileTypeDefinitionDto.source;
    label?: string;
}

export namespace AccidentReviewCsiFileTypeDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
